export const monthlyPeriodNames = {
  3: ["Q1", "Q2", "Q3", "Q4"],
  4: ["T1", "T2", "T3"],
  6: ["H1", "H2"],
};
